import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import dotProductCommons from './commons/dot_product.js'

const level = new Level({
    name: 'dot_product_with_unit',
    dependencies: [
        'levels_maths/dot_product_with_ortho_unit'
    ]
})


function common (q, params) {

    let vectors = dotProductCommons.vectors(params)

    dotProductCommons.displayVectors(q, vectors, params)

    dotProductCommons.question(q, vectors)

}


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: 1,
            uY: 0,
            vX: random.fairChoiceInt(2, 7, {name: 'vx'}),
            vY: random.fairChoiceInt(1, 5, {name: 'vy'}),
            angle: random.fairChoice([30, 140, -50], {name: 'angle'}),
            noGrid: true
        })
    }
})



level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: 1,
            uY: 0,
            vX: random.fairChoiceInt(2, 7, {name: 'vx'}),
            vY: random.fairChoiceInt(1, 5, {name: 'vy'}),
            angle: random.fairChoice([30, 140, -50], {name: 'angle'})
        })
    },
    times: 2
})



export default level

